/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5310:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7112);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6753);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var SearchModal = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SearchModal, _HTMLElement);

  var _super = _createSuper(SearchModal);

  function SearchModal() {
    var _document$querySelect;

    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, SearchModal);

    _this = _super.call(this);
    var searchTrigger = document.querySelector(".search-trigger");

    var form = _this.querySelector(".form");

    var header = document.querySelector(".header");

    var input = _this.querySelector(".form__input");

    var submit = _this.querySelector(".form__submit");

    var predictiveSearchResultsSectionId = (_document$querySelect = document.querySelector(".predictive-search-results")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("data-section-id");
    var searchHolder = document.querySelector(".predictive-search-modal");
    var mobileInput = document.querySelector('.mobile-navigation form input[type="text"]');
    var mobileSearch = document.querySelector('.mobile-navigation form');
    var mobileNavigation = document.querySelector(".mobile-navigation");
    var mobileSearchInput = document.querySelector("#input-search-mobile"); // Hide search modal by default

    _this.classList.add("search-hidden");

    var syncSearchInputs = function syncSearchInputs(e) {
      var value = e.target.value;

      if (e.target.id === "input-search-mobile") {
        input.value = value;
        input.dispatchEvent(new Event("input", {
          bubbles: true
        }));
      } else {
        mobileSearchInput.value = value;
      }
    };

    input === null || input === void 0 ? void 0 : input.addEventListener("input", syncSearchInputs);
    mobileSearchInput === null || mobileSearchInput === void 0 ? void 0 : mobileSearchInput.addEventListener("input", syncSearchInputs);
    searchHolder.style.transform = "translateY(32px)";

    var handleCloseSuggestionListener = function handleCloseSuggestionListener() {
      var suggestBackground = document.querySelector(".js-suggestion-background");
      var suggestionsHolder = document.querySelector(".suggestions-holder");
      suggestBackground.addEventListener("mouseover", function () {
        suggestionsHolder === null || suggestionsHolder === void 0 ? void 0 : suggestionsHolder.classList.remove("suggestions-holder--active");
        suggestBackground === null || suggestBackground === void 0 ? void 0 : suggestBackground.classList.remove("background-curtain--active");
        hideSearch();
      });
    };

    var showEmptySearch = function showEmptySearch() {
      var backgroundCurtain = document.querySelector(".background-curtain");
      var popularResults = document.querySelector(".popular-results");
      backgroundCurtain === null || backgroundCurtain === void 0 ? void 0 : backgroundCurtain.classList.add("background-curtain--active");
      popularResults === null || popularResults === void 0 ? void 0 : popularResults.classList.add("js-active");
    };

    var handleBackdrop = function handleBackdrop() {
      var backdrop = document.querySelector(".predictive-search-results .js-base-background");
      var predictiveSearch = document.querySelector(".search-results-holder");
      backdrop.addEventListener("mouseover", function (e) {
        predictiveSearch.remove();
        backdrop.remove();
      });
    };

    var hideSearch = function hideSearch() {
      var backdrop = document.querySelector(".predictive-search-results .js-base-background");
      var predictiveSearch = document.querySelector(".search-results-holder");
      predictiveSearch === null || predictiveSearch === void 0 ? void 0 : predictiveSearch.remove();
      backdrop === null || backdrop === void 0 ? void 0 : backdrop.remove();

      _this.classList.add("search-hidden");
    };

    if (searchTrigger) {
      searchTrigger.addEventListener("click", function () {
        var mobileMenuTrigger = document.querySelector("#js-trigger-mobile-menu");

        if (window.innerWidth < 1024) {
          // Check if mobile nav is not already open
          if (!mobileNavigation.classList.contains("js-mobile-navigation-open")) {
            mobileNavigation.classList.add("js-mobile-navigation-open"); // Update mobile menu trigger icon

            mobileMenuTrigger === null || mobileMenuTrigger === void 0 ? void 0 : mobileMenuTrigger.classList.add("is-open");
            setTimeout(function () {
              mobileInput === null || mobileInput === void 0 ? void 0 : mobileInput.focus();
              mobileSearch.style.display = "flex";
            }, 100);
          } else {
            mobileInput === null || mobileInput === void 0 ? void 0 : mobileInput.focus();
            mobileSearch.style.display = "flex";
          }
        } else {
          form.classList.add("form--active");
          header.classList.add("js-active");

          _this.classList.remove("search-hidden");

          if (form.classList.contains("form--active")) {
            setTimeout(function () {
              input === null || input === void 0 ? void 0 : input.focus();
            }, 100);
          }
        }
      });
    }
    /**
     * @param {HTMLDom} dom
     * @param {sectionsArray} sectionsArray
     * renders product filters
     */


    var renderSections = function renderSections(dom, sectionsArray) {
      sectionsArray.forEach(function (section) {
        var source = dom.querySelector(section);
        var destination = document.querySelector(section);
        destination.innerHTML = source.innerHTML;
      });
    };

    var handleSearchInput = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_3__/* .debounce */ .D)(function (searchTerm) {
      var sectionsArray = [".predictive-search-results-holder"];
      var searchResults = document.querySelector(".search-results-holder");
      var suggestionsHolder = document.querySelector(".suggestions-holder");
      var url = "/search/suggest?q=".concat(searchTerm, "&resources[type]=product,collection,article&section_id=").concat(predictiveSearchResultsSectionId);

      if (searchTerm !== "") {
        // If there are existing search results, fade them
        if (searchResults) {
          searchResults.querySelectorAll('*').forEach(function (el) {
            el.style.opacity = '0.8';
            el.style.transition = 'opacity .35s ease';
          });
        } // Fade out suggestions holder and its contents


        if (suggestionsHolder) {
          suggestionsHolder.querySelectorAll('*').forEach(function (el) {
            el.style.opacity = '0.8';
            el.style.transition = 'opacity .35s ease';
          });
        }

        axios__WEBPACK_IMPORTED_MODULE_2___default().get(url).then(function (response) {
          var parser = new DOMParser();
          var dom = parser.parseFromString(response.data, "text/html");
          renderSections(dom, sectionsArray);
          handleBackdrop();
        }).catch(function (error) {
          throw error;
        }).finally(function () {
          // Remove loading state
          if (searchResults) {
            searchResults.style.opacity = '1';
          }
        });
      } else {
        hideSearch(); // Show suggestions holder and its contents when search is empty

        if (suggestionsHolder) {
          suggestionsHolder.style.opacity = '1';
          suggestionsHolder.querySelectorAll('*').forEach(function (el) {
            el.style.opacity = '1';
          });
        }
      }
    }, 300);

    if (input) {
      input.addEventListener("input", function (e) {
        input.value !== "" ? submit.classList.add("js-active") : submit.classList.remove("js-active");
        handleSearchInput(e.target.value);
        showEmptySearch();

        if (input.value === '') {
          hideSearch();
        }
      }); // input.addEventListener('blur', () => {
      //   form.classList.toggle('form--active')
      //   submit.classList.remove('js-active')
      // hideSearch()
      // })

      input.addEventListener("focus", function () {
        var suggestionsHolder = document.querySelector(".suggestions-holder");
        var suggestionBackground = document.querySelector(".js-suggestion-background");
        suggestionsHolder === null || suggestionsHolder === void 0 ? void 0 : suggestionsHolder.classList.add("suggestions-holder--active");
        suggestionBackground === null || suggestionBackground === void 0 ? void 0 : suggestionBackground.classList.add("background-curtain--active");
        handleCloseSuggestionListener();
      });
      mobileInput.addEventListener("focus", function () {
        var suggestionsHolder = document.querySelector(".suggestions-holder");
        var suggestionBackground = document.querySelector(".js-suggestion-background");
        suggestionsHolder === null || suggestionsHolder === void 0 ? void 0 : suggestionsHolder.classList.add("suggestions-holder--active");
        suggestionBackground === null || suggestionBackground === void 0 ? void 0 : suggestionBackground.classList.add("background-curtain--active");
        handleCloseSuggestionListener();
      });
    }

    return _this;
  }

  return SearchModal;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(HTMLElement)); // Check if element is defined, if not define it..


if (customElements.get("search-modal") === undefined) {
  customElements.define("search-modal", SearchModal);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 5668;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			5668: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(5310); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;